export enum PaginationOperator {
    None = 'None',
    Equals = 'Equals',
    NotEqual = 'NotEqual',
    Contains = 'Contains',
    GreaterThan = 'GreaterThan',
    LessThan = 'LessThan',
    GreaterThanEqual = 'GreaterThanEqual',
    LessThanEqual = 'LessThanEqual'
}